import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, CheckCircle, Loader2 } from 'lucide-react';
import { AdminApi } from '../../services/api';
import { BOUTON_AUTH, CHAMP_AUTH, CadreAuth } from './CadreAuth';

/** Réponse affichée quelle que soit l'adresse : on ne révèle pas si un compte existe. */
export const MESSAGE_LIEN_ENVOYE = 'Si cette adresse correspond à un compte du personnel, un e-mail avec un lien valable une heure vient de partir.';

/** Page /mot-de-passe-oublie : demande d'un lien de réinitialisation (personnel uniquement). */
export const MotDePasseOublie: React.FC = () => {
  const [email, setEmail] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [envoye, setEnvoye] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);

  const envoyer = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) { setErreur('Saisissez votre adresse e-mail.'); return; }
    setEnvoi(true);
    setErreur(null);
    try {
      await AdminApi.demanderReinitialisation(email.trim());
      setEnvoye(true);
    } catch (err) {
      // Seul un échec technique (trop de demandes, serveur injoignable) est affiché.
      setErreur(err instanceof Error ? err.message : "La demande n'a pas pu être envoyée. Réessayez plus tard.");
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <CadreAuth titre="Mot de passe oublié" sousTitre="Recevez un lien pour choisir un nouveau mot de passe.">
      {envoye ? (
        <div role="status" className="mt-8 p-4 bg-sapin-50 border border-sapin-200 rounded-lg flex items-start gap-3 text-sapin-900 text-sm">
          <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
          <p>{MESSAGE_LIEN_ENVOYE}</p>
        </div>
      ) : (
        <>
          {erreur && (
            <div role="alert" className="mt-6 p-3.5 bg-red-50 border border-red-200 rounded-lg flex items-center gap-3 text-red-800 text-sm">
              <AlertCircle className="w-5 h-5 flex-shrink-0" /><p>{erreur}</p>
            </div>
          )}
          <form onSubmit={envoyer} className="mt-8 space-y-5" noValidate>
            <div>
              <label htmlFor="email-oubli" className="block text-sm font-semibold text-encre mb-1.5">Adresse e-mail</label>
              <input id="email-oubli" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="prenom@klygroupe.com" autoComplete="username" className={CHAMP_AUTH} />
            </div>
            <button type="submit" disabled={envoi} className={BOUTON_AUTH}>
              {envoi ? <><Loader2 className="w-5 h-5 animate-spin" /><span>Envoi</span></> : <span>Recevoir le lien</span>}
            </button>
          </form>
        </>
      )}
      <Link to="/login" className="mt-8 inline-flex items-center min-h-[40px] lg:min-h-0 text-sm text-sapin-700 hover:text-sapin-900 font-semibold">Retour à la connexion</Link>
    </CadreAuth>
  );
};

export default MotDePasseOublie;
